'use client';

import { useTranslations } from 'next-intl';
import { ConfirmationDialog } from '../../confirmation-dialog';

export type DisconnectSourceCodeDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isLoading: boolean;
};

export function DisconnectSourceCodeDialog({
  isOpen,
  onOpenChange,
  onConfirm,
  isLoading,
}: DisconnectSourceCodeDialogProps) {
  const t = useTranslations(
    'designSystem.applicationSettings.sourceCode.disconnectDialog',
  );
  const tCommon = useTranslations('designSystem.common');

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onOpenChange={({ open }) => onOpenChange(open)}
      onConfirm={onConfirm}
      loading={isLoading}
      variant="destructive"
      title={t('title')}
      description={t('description')}
      confirmText={t('disconnect')}
      cancelText={tCommon('cancel')}
    />
  );
}
